<template>
  <!-- CP-127: active filters returned nothing. Short line + actions only. -->
  <EmptyState :type="type" :message="line" class="filter-empty-recovery" role="status">
    <div class="recovery-actions">
      <button type="button" class="recovery-clear" @click="$emit('clear-all')">
        Clear all filters
      </button>
    </div>
    <div
      v-if="options.length > 1"
      class="recovery-relax"
      role="group"
      aria-label="Remove one filter"
    >
      <button
        v-for="opt in options"
        :key="opt.key"
        type="button"
        class="recovery-chip"
        @click="$emit('relax', opt)"
      >
        <span>Remove {{ opt.label }}</span>
        <i class="fas fa-times" aria-hidden="true"></i>
      </button>
    </div>
  </EmptyState>
</template>

<script>
import EmptyState from '@/components/EmptyState.vue';
import { EMPTY_RECOVERY_LINE } from '@/utils/emptyRecovery';

export default {
  name: 'FilterEmptyRecovery',
  components: { EmptyState },
  emits: ['clear-all', 'relax'],
  props: {
    type: {
      type: String,
      default: 'cruises',
      validator: (v) => v === 'cruises' || v === 'deals'
    },
    // [{ key, label, patch }] from browseRelaxOptions / dealRelaxOptions,
    // most restrictive first.
    options: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    line() {
      return EMPTY_RECOVERY_LINE[this.type] || EMPTY_RECOVERY_LINE.cruises;
    }
  }
};
</script>

<style scoped>
/* Global img reset makes the illustration block-level; keep it centred here. */
.filter-empty-recovery :deep(.empty-state-img) {
  display: block;
  margin: 0 auto;
}

.recovery-actions {
  display: flex;
  justify-content: center;
}

.recovery-clear {
  min-height: var(--touch-min);
  padding: var(--space-3) var(--space-5);
  background-color: var(--cs-fill);
  color: white;
  border: none;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: background var(--transition-normal);
}

.recovery-clear:hover {
  background-color: var(--cs-fill-hover);
}

.recovery-relax {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: var(--space-2);
  margin-top: var(--space-4);
}

.recovery-chip {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
  min-height: var(--touch-min);
  padding: var(--space-2) var(--space-3);
  background: var(--color-surface);
  color: var(--color-text);
  border: 1px solid var(--color-border);
  border-radius: var(--radius-pill);
  font-size: var(--text-small);
  cursor: pointer;
  max-width: 100%;
}

.recovery-chip span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.recovery-chip:hover {
  border-color: var(--cs-signal-teal);
}

.recovery-clear:focus-visible,
.recovery-chip:focus-visible {
  outline: 2px solid var(--color-primary);
  outline-offset: 2px;
}
</style>
